import { css } from 'styled-components';
const generateHiddenFor = (theme, breakP) => {
    const breakPointsMap = {
        Xs: { next: 'S' },
        S: { next: 'M' },
        M: { next: 'L' },
        L: { next: 'Xl' },
        Xl: {}
    };
    const breakPLowerC = breakP.toLowerCase();
    const breakPN = parseInt(theme[`SizeBreakpoints${breakP}`], 10);
    const breakPNextN = breakPointsMap[breakP].next &&
        parseInt(theme[`SizeBreakpoints${breakPointsMap[breakP].next}`], 10);
    const breakPMinWidthSt = `(min-width: ${breakPN}px)`;
    const breakPMaxWidthSt = breakPNextN && `(max-width: ${breakPNextN - 1}px)`;
    const andBreakPMaxWidthSt = breakPMaxWidthSt ? `and ${breakPMaxWidthSt}` : '';
    const addBreakPMaxWidthSt = breakPMaxWidthSt
        ? `@media ${breakPMaxWidthSt} {.ndsHidden-${breakPLowerC}-down {display: none !important;}}`
        : '';
    return `

    /* e.g. Xs 0 >=  WIDTH <= 767px */
    @media ${breakPMinWidthSt} ${andBreakPMaxWidthSt} {
      .ndsHidden-${breakPLowerC} {
        display: none !important;
      }
    }

    /* e.g. Xs WIDTH <= 767px */
    ${addBreakPMaxWidthSt}

    /* e.g. Xs WIDTH >= 0x */
    @media ${breakPMinWidthSt} {
      .ndsHidden-${breakPLowerC}-up {
        display: none !important;
      }
    }
  `;
};
export default css `

 ${(props) => generateHiddenFor(props.theme, 'Xs')}
 ${(props) => generateHiddenFor(props.theme, 'S')}
 ${(props) => generateHiddenFor(props.theme, 'M')}
 ${(props) => generateHiddenFor(props.theme, 'L')}
 ${(props) => generateHiddenFor(props.theme, 'Xl')}

`;
//# sourceMappingURL=UtilsVisibility.js.map